import React, { useCallback, useEffect, useRef, useState } from "react";
import { DropdownImg, DropdownListItem, DropdownAccountNumber, DropdownDiv } from './SelectAccount.styles';
import Select from "syf-component-library/ui/atoms/Select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
function isVistaPlatform(platform) {
    return platform === "VISTA";
}
function isPeaksPlatform(platform) {
    return platform === "PEAKS";
}
function isPeaksDataAvailable(appConfig) {
    const userMetaData = appConfig.main.userMetadata;
    return (isPeaksPlatform(appConfig.main.platform) && !!userMetaData && userMetaData.platformInformation && userMetaData.platformInformation.length > 0);
}
function checkForResponseName(response) {
    let responseName = "";
    if (Array.isArray(response === null || response === void 0 ? void 0 : response.responseActions) && !!(response === null || response === void 0 ? void 0 : response.responseActions.length)) {
        responseName = response === null || response === void 0 ? void 0 : response.responseActions[response.responseActions.length - 1].Name;
    }
    return responseName === 'SwitchAccountRevertUItoCurrentEnterpriseID';
}
function getAccountType(productType) {
    if (productType === "INSTALLMENT_LOAN" ||
        productType === "INSTALLMENT_LOAN_MONTHLY" ||
        productType === "INSTALLMENT_LOAN_PAY_IN_FOUR") {
        return "Loan ending in ";
    }
    else {
        return "Account ending in ";
    }
}
const canShowSelectAccount = (appConfig) => {
    return (isVistaPlatform(appConfig.main.platform) && !!appConfig.main.userMetadata) || isPeaksDataAvailable(appConfig);
};
const getCurrentEnterpriseId = (appConfig, currentEnterpriseId) => {
    const userMetadata = appConfig.main.userMetadata;
    return isPeaksPlatform(appConfig.main.platform) && currentEnterpriseId === undefined ? userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.currentEnterpriseId : currentEnterpriseId;
};
const updateSelectedAccount = (currentEnterpriseId, selected, setSelected, options, isAccountSwitched, isAccountChanged) => {
    if ((!isAccountChanged.current && isAccountSwitched.current && currentEnterpriseId && selected.value !== currentEnterpriseId) || (currentEnterpriseId && selected.value && selected.value !== currentEnterpriseId)) {
        const selectedOption = options.filter(x => x.value === currentEnterpriseId);
        setSelected(selectedOption[0]);
        isAccountSwitched.current = false;
    }
    else if (isAccountSwitched.current && currentEnterpriseId && selected.value === currentEnterpriseId) {
        isAccountSwitched.current = false;
    }
    else if (isAccountChanged.current) {
        isAccountChanged.current = false;
    }
};
const getUserMetaData = (appConfig) => {
    var _a;
    return isVistaPlatform((_a = appConfig.main) === null || _a === void 0 ? void 0 : _a.platform) ? appConfig.main.userMetadata : appConfig.main.userMetadata;
};
export const SelectAccount = (props) => {
    var _a;
    const UserMetaData = getUserMetaData(props.almeAppConfig);
    const platformInformationData = UserMetaData === null || UserMetaData === void 0 ? void 0 : UserMetaData.platformInformation;
    const currentEnterpriseId = getCurrentEnterpriseId(props.almeAppConfig, props.currentEnterpriseId);
    const options = [];
    const isAccountChanged = useRef(false);
    let selectedIndex = 0;
    if (platformInformationData instanceof Object && UserMetaData) {
        Object.values(platformInformationData).forEach((item, index) => {
            const accountNumberText = getAccountType(item.productType.toUpperCase()) + item.accountNumber;
            options.push({
                element: (React.createElement(DropdownDiv, null,
                    React.createElement(DropdownImg, { src: item.imageURL, alt: "Stickman", "aria-hidden": "true" }),
                    React.createElement("div", { key: index },
                        React.createElement(DropdownListItem, null, item.cardName),
                        React.createElement(DropdownAccountNumber, null, accountNumberText)))),
                value: `${item.enterpriseId}`,
                label: `${item.cardName}[${accountNumberText}]`,
            });
            if (item.enterpriseId === currentEnterpriseId) {
                selectedIndex = index;
            }
        });
    }
    const managefocus = useCallback((event) => {
        if (event.key === "Escape") {
            const comboboxElement = document.getElementById('ddlCardDropdown-combobox');
            if (comboboxElement && document.activeElement === document.body) {
                event.preventDefault();
                comboboxElement.focus();
            }
        }
    }, []);
    const [selected, setSelected] = useState(options[selectedIndex]);
    useEffect(() => {
        document.addEventListener("keydown", managefocus, false);
        return () => {
            document.removeEventListener("keydown", managefocus, false);
        };
    }, [managefocus]);
    if (!canShowSelectAccount(props.almeAppConfig)) {
        return null;
    }
    updateSelectedAccount(currentEnterpriseId, selected, setSelected, options, props.isAccountSwitched, isAccountChanged);
    async function sendEligAppEvent(option, selectedTenant) {
        const params = isPeaksPlatform(props.almeAppConfig.main.platform) ? { "enterpriseIdToSwitchTo": option.value, "UserObj": props.almeAppConfig.main.userMetadata } : { "enterpriseIdToSwitchTo": option.value };
        await props.almeApiUtils.sendAppEvent("SwitchAccountEligibility", undefined, params)
            .then((response) => {
            checkForResponseName(response) ? setSelected(selectedTenant) : props.almeApiUtils.processSendAccountEligibilityResponse(response);
            props.almeApiUtils.appendToHistory(response);
        });
    }
    const handleChange = (option) => {
        if (option.value !== selected.value) {
            setSelected(option);
            isAccountChanged.current = true;
            sendEligAppEvent(option, selected).catch((error) => console.log(`Error occured in SwitchAccountEligibilty ${error}`));
        }
    };
    return (React.createElement(Select, { name: "CardDropdown", leftIcon: React.createElement("img", { width: "40", height: "40", src: (_a = platformInformationData === null || platformInformationData === void 0 ? void 0 : platformInformationData.find(x => x.enterpriseId === selected.value)) === null || _a === void 0 ? void 0 : _a.imageURL, alt: "Stickman", "aria-hidden": "true" }), id: "ddlCardDropdown", onChange: handleChange, tabIndex: 0, placeholder: "Card Name", options: options, defaultOption: selected, rightIconOpen: React.createElement(FontAwesomeIcon, { icon: ['far', 'chevron-up'] }), rightIconClosed: React.createElement(FontAwesomeIcon, { icon: ['far', 'chevron-down'] }), isDisabled: props.isLiveChatConnected }));
};
